import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex/index.tsx';
import { BrandL, BrandXL } from '@sorare/core/src/atoms/typography/index.tsx';
import type { HexColor } from '@sorare/core/src/style/types.ts';

const Wrapper = styled(Horizontal).attrs({ center: true })`
  position: relative;
  padding: 2px var(--intermediate-unit);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border: 1.5px solid var(--border-color);
    border-radius: 4px;
    mask:
      linear-gradient(#fff, #fff) 0 0,
      linear-gradient(#fff, #fff) 100% 0,
      linear-gradient(#fff, #fff) 100% 100%,
      linear-gradient(#fff, #fff) 0 100%;
    mask-size: var(--unit) var(--unit);
    mask-repeat: no-repeat;
  }
`;

type Props = { score: number; color: HexColor };
export const BracketedScore = ({ score, color }: Props) => {
  return (
    <Wrapper style={{ '--border-color': color } as CSSProperties}>
      <BrandL color={color}>
        <FormattedMessage
          defaultMessage="<span>{score, number, ::. rounding-mode-down}</span>pts"
          values={{
            score,
            span: chunks => <BrandXL as="span">{chunks}</BrandXL>,
          }}
        />
      </BrandL>
    </Wrapper>
  );
};
